import { render } from "./InspectorTable.vue?vue&type=template&id=7dcf06ea&scoped=true"
import script from "./InspectorTable.vue?vue&type=script&lang=js"
export * from "./InspectorTable.vue?vue&type=script&lang=js"

import "./InspectorTable.vue?vue&type=style&index=0&id=7dcf06ea&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcf06ea"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QIcon,QList,QItem,QItemSection,QItemLabel});qInstall(script, 'directives', {ClosePopup});
